import useAppTranslation from "@hooks/language/useAppTranslation";
import SEO from "@modules/seo/SEO";
import { Trans } from "react-i18next";
import helpCenter1 from "../assets/changeEmail_1.webp";
import helpCenter2 from "../assets/changeEmail_2.webp";
import helpCenter3 from "../assets/changeEmail_3.webp";
import helpCenter4 from "../assets/changeEmail_4.webp";
import helpCenter5 from "../assets/changeEmail_5.webp";
import helpCenter6 from "../assets/changeEmail_6.webp";
import HelpCenterContainer from "../components/HelpCenterContainer";
import HelpCenterDiscordLink from "../components/HelpCenterDiscordLink";
import HelpCenterImage from "../components/HelpCenterImage";
import HelpCenterLink from "../components/HelpCenterLink";
import HelpCenterSubTitle from "../components/HelpCenterSubTitle";
import HelpCenterText from "../components/HelpCenterText";
import HelpCenterTitle from "../components/HelpCenterTitle";

const HowToChangeEmailAndPassword = () => {
  const { t } = useAppTranslation("pages.helpCenter.changeEmail");

  return (
    <>
      <SEO title={t("seo.title")} description={t("seo.description")} />
      <HelpCenterContainer title={t("title")}>
        <HelpCenterText>{t("intro")}</HelpCenterText>

        <HelpCenterTitle>{t("step1.title")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans t={t} i18nKey="step1.text">
            Pour commencer, vous devez vous connecter à votre compte Riot Games.
            Rendez-vous sur la page de connexion de Riot Games ici:
            <HelpCenterLink>https://authenticate.riotgames.com/</HelpCenterLink>
            Entrez vos identifiants (identifiant et mot de passe) de votre
            compte.
          </Trans>
        </HelpCenterText>

        <HelpCenterImage src={helpCenter1} className="md:min-w-[50%]" />

        <HelpCenterTitle>{t("step2.title")}</HelpCenterTitle>

        <HelpCenterText>{t("step2.text")}</HelpCenterText>

        <HelpCenterTitle>{t("step3.title")}</HelpCenterTitle>

        <HelpCenterSubTitle>{t("step3.subTitleEmail")}</HelpCenterSubTitle>

        <HelpCenterText>{t("step3.textEmail1")}</HelpCenterText>

        <HelpCenterImage src={helpCenter2} />

        <HelpCenterText>{t("step3.textEmail2")}</HelpCenterText>

        <HelpCenterImage src={helpCenter3} />

        <HelpCenterText>{t("step3.textEmail3")}</HelpCenterText>

        <HelpCenterSubTitle>{t("step3.subTitlePassword")}</HelpCenterSubTitle>

        <HelpCenterText>{t("step3.textPassword1")}</HelpCenterText>

        <HelpCenterImage src={helpCenter4} />

        <HelpCenterText>{t("step3.textPassword2")}</HelpCenterText>

        <HelpCenterImage src={helpCenter5} />

        <HelpCenterText>{t("step3.textPassword3")}</HelpCenterText>

        <HelpCenterTitle>{t("step4.title")}</HelpCenterTitle>

        <HelpCenterText>{t("step4.text")}</HelpCenterText>

        <HelpCenterImage src={helpCenter6} />

        <HelpCenterTitle>{t("conclusion.title")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans t={t} i18nKey="conclusion.text">
            En suivant ces étapes, vous aurez mis à jour avec succès l'e-mail et
            le mot de passe de votre compte League of Legends. Garder vos
            informations à jour et sécurisées est essentiel pour profiter
            pleinement de votre expérience de jeu en toute tranquillité. Si vous
            rencontrez des problèmes ou avez des questions supplémentaires,
            n'hésitez pas à nous contacter via notre <HelpCenterDiscordLink />.
          </Trans>
        </HelpCenterText>
      </HelpCenterContainer>
    </>
  );
};

export default HowToChangeEmailAndPassword;
